<div>
  <form [formGroup]="deductionForm" (ngSubmit)="onSubmit()">
    <mat-dialog-content>
      <p>
        Вы пытаетесь деативировать студента {{ student?.full_name }}. У студента
        не будет доступа к материалу который он уже получил, также студент не
        сможет зайти в crm систему под своим профилем. Чтобы вернуть студента в
        группу, нужно снова активировать его профиль и через вкладку "Курсы и
        Группы" => Выбрать группу => "Студенты" => "Отчисленные" снова его
        активировать в группе.
      </p>
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Причина деактивации:</mat-label>
        <textarea matInput formControlName="text"> </textarea>
      </mat-form-field>
    </mat-dialog-content>
    <div mat-dialog-actions class="justify-content-end">
      <button type="button" class="mr-2" mat-raised-button (click)="onCancel()">
        Отмена
      </button>
      <app-button-with-progress
        typeBtn="submit"
        [loading$]="sendLoading$ | async"
        label="Сохранить"></app-button-with-progress>
    </div>
  </form>
</div>
